import template from './sw-cms-el-preview-acris-blog-title.html.twig';
import './sw-cms-el-preview-acris-blog-title.scss';

const { Component } = Shopware;

Component.register('sw-cms-el-preview-acris-blog-title', {
    template
});